var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"norele"},[_c('div',{staticClass:"description-box"},[_vm._v(" 请您把自己的"),_c('span',{staticClass:"color-red"},[_vm._v("用户名")]),_vm._v("提供给自己的管理者，管理者会给与相应的权限！然后"),_c('span',{staticClass:"color-red pointer",on:{"click":_vm.toPage}},[_vm._v("重新登录")]),_vm._v("即可启用 ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }